var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.selectModel(_vm.modelValue,_vm.dataSelectorKey))?_c('v-chip',{attrs:{"outlined":_vm.outlined,"x-small":"","label":"","color":_vm.getColor()}},[_vm._v(" "+_vm._s(_vm.selectModel(_vm.modelValue,_vm.dataSelectorKey))+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }